/* 
  Affiliate validation
*/
var Affiliates = (function (window, $, UrlParameter, CartJS, env, shop_domain) {
  
  var discount_code,
      refersion_env,
      refersion_url;

  var problemPageUrl = '//' + shop_domain + '/pages/affiliate-error';
  var logger = log.getLogger('affiliates.js');
  logger.setLevel(logger.levels.INFO);
  var education_offer_id = {
    'ttp-dev': '8747',
    'ttp-stage': '8747',
    'ttp-prod': '8791',
    'msg': '17602'
  }

  var defaults = {
    discount_code: 'JX1ZYE3T9TWN',
    refersion_env: 'ttp-prod',
    refersion_url: '//' + shop_domain + '/affiliates/validate_user/?ref_id='
  };

  var willUnload = false;

  var initialize = function (options) {
    logger.debug('Initializing affiliates module...');

    discount_code = options.discount_code || defaults.discount_code;
    refersion_env = options.refersion_env || defaults.refersion_env;
    refersion_url = options.refersion_url || defaults.refersion_url;

    if (isCheckout()) {
      validateCheckout();
    } else if (isCheckoutRedirect()) {
      return;
    } else {
      validateUrl();
    }
  };

  var parseOmnistar = function (hash) {
    var oid = '';
    var regex = /(#oid=)(.*)/;
    if (hash.match(regex)) {
      oid = hash.replace(regex, '$2');
    }
    return oid;
  };

  var validateUrl = function() {
    logger.trace('validateUrl()');

    var query = window.location.search;
    var refersion_id = UrlParameter.get(query, 'rfsn');
    var motivity_id = UrlParameter.get(query, 'code');
    var omnistar_id = parseOmnistar(window.location.hash);
    var json_file;

    if (omnistar_id !== '') {
      logger.debug('Found an Omnistar code in the URL hash');
      setAffiliateCode(null);
      json_file = "//www.thinktankphoto.com/cdn/shop/t/162/assets/omnistar_to_refersion.json?v=131061006824289348151785776338";
      $.getJSON(json_file, function (response) {
        validateMapping(omnistar_id, response);
      })
      validateCookie();
    } else if (typeof(motivity_id) !== 'undefined' && motivity_id !== '') {  
      logger.debug('Found a Motivity code in the URL');
      setAffiliateCode(null);
      json_file = "//www.thinktankphoto.com/cdn/shop/t/162/assets/motivity_to_refersion.json?v=41523189002334642861785776338";
      $.getJSON(json_file, function(response){
        validateMapping(motivity_id, response);
      })
      validateCookie();
    } else if (typeof(refersion_id) !== 'undefined' && refersion_id !== '') {
      logger.debug('Found a Refersion code in the URL');
      $.getJSON("//www.thinktankphoto.com/cdn/shop/t/162/assets/msg_to_ttp_refersion.json?v=88966946526650457791785776338", function (response) {
        logger.debug('Check for matching Refersion code in MSG/TTP mapping table');
        var mapped_refersion_id = response[refersion_id];
        if (typeof(mapped_refersion_id) !== 'undefined' && mapped_refersion_id !== '') {
          window.location.href = UrlParameter.update(
            window.location.href,
            'rfsn',
            mapped_refersion_id
          );
        }
        logger.debug('Validate the Refersion code and alternatively set the cookie or fail');
        if (refersion_id.split('.').length >= 2 && refersion_id.split('.')[0].length >= 6) {
          setAffiliateCode('refersion', refersion_id);
        } else {
          failedValidation();
        }
        validateCookie();
      });
    } else if (typeof(affiliateLandingPage) !== 'undefined' &&
               affiliateLandingPage === true &&
               motivity_id === '') {
      failedValidation();
      validateCookie();
    } else {
      validateCookie();
    }

  };

  var validateMapping = function(affiliate_id, mapping) {
    logger.trace('validateMapping(' + affiliate_id + ')');

    var get_url;
    var new_url;
    var refersion_id = mapping[affiliate_id.toUpperCase()];

    if (typeof(refersion_id) !== 'undefined'){

      $('#affiliateModal').modal({
        backdrop: 'static',
        keyboard: false
      })

      if (document.title.indexOf('Page Not Found') > -1) {
        new_url = location.protocol + '//' + location.host + '/?rfsn=' + refersion_id[0];
        $('#old_referral').text(
          "It looks like you found a product that is no longer sold online and got here with an old affiliate code. " +
          "Since our affiliates program has been updated, please use the following link to continue making a purchase. " +
          "You'll still get your loyalty reward and your affiliate will be notified no matter what you buy. Thanks!");
      } else {
        new_url = UrlParameter.remove(window.location.href, 'code')
        new_url = new_url.split('#')[0] + '?rfsn=' + refersion_id[0];
      }

      $('#old_referral').css('display', 'block');
      $('#referral_url').css('display', 'block');
      $('#referral_url').attr('href', new_url); //show affiliate_url
      $('#referral_url').text(new_url); //show affiliate_url

    } else {
      failedValidation();
    }
  };

  var validateCookie = function () {
    logger.trace('validateCookie()');

    var page_title = window.location.pathname.split('/')[2];
    var affiliate_program = window.getCookie('affiliate_program');
    var affiliate_code = window.getCookie('affiliate_code');
    var affiliate_id;

    if (typeof(affiliate_code) !== 'undefined' && affiliate_program === 'refersion') {
      logger.debug('Found a Refersion code in the cookie', affiliate_code);
      if (affiliate_code.split('.').length >= 2) {
        affiliate_id = affiliate_code.split('.')[0];
        if (affiliate_id.length > 0) {
          if (window.document.title.indexOf('Page Not Found') > -1) {
            logger.debug('Refersion 404 message')
            $('#refersion_text').text(
              "It looks like you found a page that isn't valid and got here with an affiliate code. " +
              "Please use the following link to continue making a purchase. " +
              "You'll still get your loyalty reward and your affiliate will be notified no matter what you buy. " +
              "Thanks!"
            );
            var referrer = location.protocol + '//' + location.host + '/?rfsn=' + affiliate_code;
            $('#refersion_href').attr('href', referrer);
            $('#refersion_href').text(referrer);
          } else {
            validateRefersion(affiliate_code);
          }
        }
      }
    } else {
      logger.debug('Invalid affiliate cookies. Clearing them');
      setAffiliateCode(null);
      configureCart('none');
    }
  };

  var validateRefersion = function (affiliate_code) {
    var url = refersion_url + affiliate_code.split('.')[0];
    url += '&env=' + refersion_env;
    url += '&_=' + new Date().getTime()
    var type;
    $.get(url)
      .done(function (response) {
        logger.debug('Validated affiliate code using Refersion API', affiliate_code)
        if (response.offer_id === education_offer_id[refersion_env]) {
          type = 'education';
        } else {
          type = 'general';
        }
        setAffiliateCode('refersion', affiliate_code, type);
        configureCart(type, affiliate_code);
        configureCheckout(type);
        configureAffiliatePage();
      })
      .fail(function () {
        failedValidation();
      });
  };

  var failedValidation = function () {
    logger.trace('failedValidation()');
    if (!willUnload) {
      setAffiliateCode(null);
      window.location.href = problemPageUrl;
    }
  };

  var setAffiliateCode = function (program, code, offer) {
    logger.trace('setAffiliateCode(' + program + ', '  + code + ', ' + offer  + ')');
    if (program === null) {
      window.eraseCookie('affiliate_program');
      window.eraseCookie('affiliate_code');
      window.eraseCookie('affiliate_offer');
    } else {
      window.setCookie('affiliate_program', program);
      window.setCookie('affiliate_code', code);
      window.setCookie('affiliate_offer', offer);
    }
  };

  var configureCart = function (type, affiliate_code) {
    logger.trace('configureCart(' + type + ')');
    if (type === 'none') {
      $('#affiliate-form').show();
      $('#free-gift').hide();
      $('#discount-code').hide();
      deleteGifts();
    }
    if (type === 'education') {
      // $('#affiliate-form').hide();
      $('#affiliate-form #oid').val(affiliate_code);
      $('#discount-code').show();
      deleteGifts();
    }
    if (type === 'general') {
      if ($('#cart').length === 0) {
        logger.debug('Not on cart page. Skipping free gift modal.');
        return;
      }
      var fgid = getFreeGiftIds();
      var cart_total = CartJS.cart.total_price;
      // $('#affiliate-form').hide();
      $('#affiliate-form #oid').val(affiliate_code);
      $('#free-gift').show();
      $('#discount-code').hide();
      if (cart_total > 5000 && fgid.length === 0){
        $('#freeGiftModal').modal('show');
        //$('#freeGiftModal').show();
      }
      deleteFreeGift();
    }
  };

  var configureAffiliatePage = function () {
    logger.trace('configureAffiliatePage()');
    $('#affiliate-message').show();
  }

  // Remove all free gifts from cart
  var deleteGifts = function () {
    logger.trace('deleteGifts()')
    var count = 0;
    var items = CartJS.cart && CartJS.cart.items || [];
    var variants;

    // delete existing "free gifts"
    for (i = 0; i < items.length; i++) {
      variants = items[i].variant_options;
      if (variants[0] == "Free"){
        count++;
        if (count > 0){
          CartJS.updateItem(i + 1, 0);
          logger.debug('Removed free gift', items[i].id);
          $("#item-" + items[i].id).remove()
        }
      }
    }
  };

  // Return an array of free gift IDs
  var getFreeGiftIds = function () {
    logger.trace('getFreeGiftIds()');
    var fgid = []
    var variant;
    for (i = 0; i < CartJS.cart.items.length; i++) {
      variant = CartJS.cart.items[i].variant_options[0];
        if (variant == "Free"){
          for (j = 0; j < CartJS.cart.items[i].quantity; j++) {
            fgid.push(CartJS.cart.items[i].id); 
          }
        }
    }
    return fgid;
  }


  // Remove free gifts if cart no longer qualifies
  var deleteFreeGift = function () {
    logger.trace('deleteFreeGift()');
    var cart_total = CartJS.cart.total_price;
    if (cart_total < 5000){
      logger.debug('delete gifts');
      deleteGifts();
    }
  };

  // Add free gift through CartJS and reload the page
  var addFreeGift = function(event) {
    logger.trace('addFreeGift()');
    var variant_id = $('input[type=radio][name=optionsRadios2]:checked').attr('value');   
    if (variant_id !== undefined) {
      event.preventDefault();
      logger.debug('Variant ID', variant_id);
      fgid = getFreeGiftIds();
      if (fgid.length > 0) {
          deleteGifts()
      }
      CartJS.addItem(variant_id, 1, {}, {
        success: function () {
          logger.debug('Added free gift', variant_id);
          window.location.reload();
        }, 
        error: function (jqXHR, text_status, error_thrown) {
          var msg = jqXHR.responseJSON.description;
          logger.error('Error adding free gift', variant_id, msg);
          alert('There was an error adding your free gift.\n' + msg);
        }
      });
    }
  };

  //form submission for checkout sequence 
  var checkout = function(event) {
    logger.trace('checkout()');
    var input_qtys = $(".item-quantity input");
    for (i = 0; i < input_qtys.length; i++) {
      if ($(input_qtys[i]).val() == 0) {
        event.preventDefault();
      } 
    }
    
    var fgid = getFreeGiftIds();
    if (fgid.length > 1 ) {
        event.preventDefault();
        alert('You may select only 1 free gift.');
    } else if (fgid.length === 1 ) {
      if (CartJS.cart.total_price < 5000){
        event.preventDefault();
        alert('You must have at least $50.00 in your cart to qualify for a free gift.');
      } else {
        var aid = getCookie('affiliate_code');
        $('#cartform').attr('action', '/cart?aid=' + aid);
      }
    } else {
      var aid = getCookie('affiliate_code');
      if (aid === undefined){
        aid = -1;
      }
      $('#cartform').attr('action', '/cart?aid=' + aid);
    }
  };  

  // affiliate code form submission
  var codeSubmit = function(event) {
      logger.trace('codeSubmit()');

      var url;
      var affiliate_code = $('#oid').val()
      var motivity_id = affiliate_code.split('-');
      var refersion_id = affiliate_code.split('.');
      
      event.preventDefault(); 

      setAffiliateCode(null);

      $('#affiliate-error').hide();
      $('#affiliate-form').removeClass('has-error');

      if (motivity_id.length == 2) {
        url = UrlParameter.remove(window.location.href, 'rfsn');
        window.location.href = UrlParameter.update(
          url,
          'code',
          affiliate_code
        );
      } else if (refersion_id.length == 2){
        window.location.href = UrlParameter.update(
          window.location.href,
          'rfsn',
          affiliate_code
        );
      } else {
        $('#affiliate-error').show();
        $('#affiliate-form').addClass('has-error');
      }

  };

  /* Checkout page logic */

  var isCheckout = function () {
    return (
      window.location.host.indexOf('checkout') === 0 ||
      (
        window.location.href.indexOf('/checkouts/') !== -1 &&
        window.location.href.indexOf('/redirect') === -1
      )
    )
  };

  var isCheckoutRedirect = function () {
    return (
      window.location.href.indexOf('/checkouts/') !== -1 &&
      window.location.href.indexOf('/redirect') !== -1
    )
  };

  var validateCheckout = function () {
    logger.trace('validateCheckout()');
    var query = window.location.search;
    var aff_id = UrlParameter.get(query, 'aid');
    if (aff_id === '') {
      aff_id = getCookie('aid');
    } else {
      setCookie('aid', aff_id);
    }
    if (aff_id !== '') {
      logger.debug('Affiliate ID', aff_id);
      validateRefersion(aff_id);
    }
  };

  var configureCheckout = function (type) {
    if (isCheckout()) {
      if (type === 'education') {
        addCheckoutDiscount();
      } else {
        removeCheckoutDiscount();
      }
    }
  };

  var addCheckoutDiscount = function () {
    logger.trace('addCheckoutDiscount()');
    if ($('.applied-reduction-code').length === 0) {
      var code_input = $('#checkout_reduction_code');
      code_input.val(discount_code);
      code_input.closest('.field__input-btn-wrapper').find('button').prop('disabled', false).click();
    }
  };

  var removeCheckoutDiscount = function () {
    logger.trace('removeCheckoutDiscount()');
    $(window.document).trigger('page:change');
    if ($.trim($('.applied-reduction-code__information').text()) === discount_code) {
      $('.applied-reduction-code__clear-button').click();
    }
  };

  /* Configure event handlers */
  $('.cart__remove').click(deleteFreeGift);
  $('#add-gift').click(addFreeGift);
  $('#checkout').click(checkout);
  $('#oid_submit').click(codeSubmit);

  $(window).on('beforeunload', function() {
    willUnload = true;
  });

  /* Configure and return module exports */
  var aff = {
    initialize: initialize
  };

  return aff;

}(window, jQuery, UrlParameter, CartJS, env, shop_domain));
  